import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ReactWordcloud from 'react-wordcloud';
import { getChartHeight } from '@utils/heights';
import { buildChartJsOptionsProp } from './options';
import './styles.scss';

export const WordCloudChart = ({ words, options, height }) => {
  words = words != undefined && words.length > 0 ? words : [];

  // Custom tooltip callback
  const getTooltip = useCallback(
    (word) => {
      if (options?.callbacks?.getTooltip) {
        return options.callbacks.getTooltip(word);
      }

      if (options?.tooltipOptions?.displayCounts) {
        return `${word.text}: ${word.value}`;
      }

      return word.text;
    },
    [options]
  );

  return (
    <div style={{ height: getChartHeight(height) }}>
      {words.length > 0 ? (
        <ReactWordcloud
          words={words}
          options={buildChartJsOptionsProp(options)}
          callbacks={{
            getTooltip,
            getWordColor: options?.callbacks?.getWordColor,
            onWordClick: options?.callbacks?.onWordClick,
            onWordMouseOver: options?.callbacks?.onWordMouseOver,
            onWordMouseOut: options?.callbacks?.onWordMouseOut,
          }}
        />
      ) : (
        <div className="word-cloud-empty">
          No data available
        </div>
      )}
    </div>
  );
};

WordCloudChart.propTypes = {
  words: PropTypes.array.isRequired,
  options: PropTypes.object,
  height: PropTypes.string
};

WordCloudChart.defaultProps = {
  options: {},
  height: 'medium'
};
